import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery, REFETCH_POLICY} from 'src/axiosBaseQuery';
import {
    CostItemExportRequest,
    DetailedTransactionDTO,
    PageTransactionDTO,
    TransactionExportRequest,
    TransactionSearchRequest,
} from 'src/types';
import {SessionStats} from 'src/types/stats';
import {getBaseURL} from 'src/utils/helper';

// initialize an empty api service that we'll inject endpoints into later as needed
export const transactionsApi = createApi({
    reducerPath: 'transactionsApi',
    ...REFETCH_POLICY,
    baseQuery: axiosBaseQuery({
        baseUrl: String(getBaseURL() + '/transactions'),
    }),
    // The list and its counts share one tag, so the websocket can bring both back in step with a
    // single invalidation when a session starts or ends.
    tagTypes: ['Transaction', 'Transactions'],
    endpoints: (build) => ({
        getTransactions: build.query<PageTransactionDTO, TransactionSearchRequest>({
            query: ({data, params}) => ({url: '/search', method: 'post', data, params}),
            providesTags: ['Transactions'],
        }),
        // The list's own body minus the status, so the tiles count exactly the rows it can show.
        getTransactionStats: build.query<SessionStats, TransactionSearchRequest['data']>({
            query: (data) => ({url: '/stats/summary', method: 'post', data}),
            providesTags: ['Transactions'],
        }),
        getTransactionById: build.query<DetailedTransactionDTO, number>({
            query: (transactionId) => ({url: `/${transactionId}`, method: 'get'}),
            providesTags: ['Transaction'],
        }),
        exportTransactions: build.mutation<Blob, TransactionExportRequest>({
            query: ({data}) => ({
                url: '/export',
                method: 'post',
                data,
                responseType: 'blob',
            }),
        }),
        exportCostItems: build.mutation<Blob, CostItemExportRequest>({
            query: (data) => ({
                url: '/costItems/export',
                method: 'post',
                data,
                responseType: 'blob',
            }),
        }),
    }),
});
